import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/badges';

export const TRACK_GET_BADGE_CLICK = `${prefix}/TRACK_GET_BADGE_CLICK`;

export const FETCH_BADGE_BY_PRETTY_ID = defineApiActionTypes(`${prefix}/FETCH_SINGLE_BY_PRETTY_ID`);

export const FETCH_ALL_BADGES = defineApiActionTypes(`${prefix}/FETCH_ALL_BADGES`);



// WEBPACK FOOTER //
// ./src/store/features/badges/action-types.js